export default __webpack_public_path__ + "89a04f48c9e983cc13880138859d146a.jpg";